<template>
	<div class="" ref="height_top" v-bind:style="{ height: tableHeight + 'px' }">
		<div style="text-align: center;">
			<img src="../../assets/img/wxatt.png" alt="">
		</div>
	</div>
</template>
<script>
export default {
	components: {},
	data() {

		return {
			tableHeight:'',

		}
	},
	props: [],

	updated() {

	},


	mounted() {

	},

	activated() {

	},
	created() {

	},
	watch: {

	},
	methods: {
		tableHeight_fun() {
			this.$nextTick(() => {
				this.tableHeight = window.innerHeight - this.$refs.height_top.getBoundingClientRect().top - 55
				console.log(this.tableHeight, 12122)
			})
		},
	}
}
</script>
<style lang="less" scoped>
</style>